<a appTrackedLink
  data-testid="help-faq-link"
  [trackId]="'header:faq'"
  [trackType]="'other'"
  mat-menu-item
  class="rkt-menu__item help-item"
  href="javascript:void(0)"
  [title]="'help-faq.MENU_LINK_LABEL' | translate"
  (click)="faqWidgetService.open()"
>
  <nova-icon name="info" [title]="'help-faq.MENU_LINK_LABEL' | translate"></nova-icon>
  <span class="help-details">{{ 'help-faq.MENU_LINK_LABEL' | translate }}</span>
</a>
